import script from "./AvatarBorder.vue?vue&type=script&setup=true&lang=js"
export * from "./AvatarBorder.vue?vue&type=script&setup=true&lang=js"

import "./AvatarBorder.vue?vue&type=style&index=0&id=4c4ca1db&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c4ca1db"]])

export default __exports__